<template>
  <div
    id="admin-account-certification-regist-admin-account"
    class="h-screen flex flex-col justify-between w-full bg-img no-gutter items-center"
    style="position: relative;"
  >
    <title-bar-area
      style="position: absolute; top: 0; left: 0;"
      :messages="messages"
    />


    <div class="aisea-text-34-400-dark-blue mb-6" style="margin-top: 4rem;">
      陸上従業員アカウント発行
    </div>
    <change-password-wizard
      v-if="isValidUrl"
      ref="changePasswordWizard"
      :wizardStartIndex="wizardStartIndex"
      :wizardStepShape="wizardStepShape"
    />
    <change-password-form
      ref="changePasswordForm"
      @setIsValidUrl="setIsValidUrl"
      @nextTab="$refs.changePasswordWizard && $refs.changePasswordWizard.nextTab()"
    />

    <footer-area />
  </div>
</template>

<script>
import TitleBarArea from "./components/TitleBarArea.vue";
import ChangePasswordWizard from "./components/RegistAdminAccountWizard.vue";
import ChangePasswordForm from "./components/RegistAdminAccountForm.vue";
import FooterArea from "./components/FooterArea.vue";

export default {
  name: "RegistAdminAccount",
  mixins: [],
  props: {
    wizardStartIndex: { type: Number, default: 0 },
    wizardStepShape: { type: String, default: "square" },
  },
  components: {
    TitleBarArea,
    ChangePasswordWizard,
    ChangePasswordForm,
    FooterArea,
  },
  data() {
    return {
      isValidUrl: false,
      messages: { titleBar: { title: "陸上従業員アカウント発行", },},
    };
  },
  computed: {
  },
  methods: {
    setIsValidUrl(val) {
      this.isValidUrl = val;
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#admin-account-certification-regist-admin-account {
  background-image: unset;
  background-color: #f6f9fa;
  --vs-primary: 3, 155, 229;
}
</style>
